export const REMOTE_SUPPORT_URL = "https://us2.ninjarmm.com/connect/#/";
export const PHONE = "318-820-0397";
export const PHONE_HREF = "tel:+13188200397";
export const EMAIL = "sv@opusconsultingllc.com";

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGRhdGElMjBzZXJ2ZXIlMjBuZXR3b3JrfGVufDB8fHx8MTc4Nzk3MDYwM3ww&ixlib=rb-4.1.0&q=85";

export const MARQUEE_ITEMS = [
  "Database Services",
  "Virtual CIO",
  "IT Architecture",
  "Data Solutions",
  "Custom Queries",
  "Extract · Transform · Load",
];

export const SERVICES = [
  {
    number: "01",
    title: "IT & Database Consulting",
    desc: "We review your workflow and systems for accurate data needs and uses — then build standalone databases and custom queries around them.",
  },
  {
    number: "02",
    title: "Extract — Transform — Load",
    desc: "Data transfer from an old software application to a new system. Help with reporting and sales tax electronic upload, delivered end-user ready.",
  },
  {
    number: "03",
    title: "Software Research & Due Diligence",
    desc: "We review and architect new software uses for your business, so every tool you adopt is vetted before you commit.",
  },
];

export const CAPABILITIES = [
  "Standalone Databases",
  "Custom Queries",
  "End-User Deliverables",
  "Software Due Diligence",
  "Reporting Help",
  "Sales Tax E-Upload",
  "Data Transfer",
  "Systems Review",
];

// Product link URLs live here — update in one place.
export const PRODUCTS = [
  {
    id: "confirmterms",
    index: "P.01",
    name: "ConfirmTerms",
    tag: "Credit approvals, verified",
    desc: "Collects and verifies trade references, so you know exactly who you are extending credit to.",
    url: "https://www.confirmterms.com",
    image: "/products/confirmterms.png",
  },
  {
    id: "field-record",
    index: "P.02",
    name: "Field Record App",
    tag: "Field data, captured right",
    desc: "Production logging built for pumpers — capture every gauge reading from the wellsite, on any device.",
    url: "https://field-record-app.preview.emergentagent.com/",
    image: "/products/field-record.png",
  },
  {
    id: "ballpark",
    index: "P.03",
    name: "Ballpark App",
    tag: "Numbers in the right ballpark",
    desc: "Online registration and booking for baseball and softball training programs.",
    url: "https://ballpark-book.preview.emergentagent.com/",
    image: "/products/ballpark.png",
  },
  {
    id: "frac-tank",
    index: "P.04",
    name: "Frac Tank Rental Management",
    tag: "Rentals, tracked end to end",
    desc: "Fleet management and day-rate billing for frac tank operations — know where your assets are and what they're earning.",
    url: "https://frac-fleet-track.preview.emergentagent.com/",
    image: "/products/frac-tank.png",
  },
];
